<template>
	<div class="downList w69 wutuUL">
		<ul>
			<li v-for="(item,index) in dataList" :key="item.ID" class="wow fadeInLeft" :data-wow-delay="index/8+'s'">
			  <router-link  :to="item.Url" :href="item.Url" class="flexDiv">
			    <p>{{item.ShowTime2}}<i>{{setTimeformat(item.ShowTime6,'YYYY-mm')}}</i></p>
			    <span>{{item.Title}}</span>
			  </router-link>
			</li>
		</ul>
	</div>
</template>

<script>
	export default{
		name:'downList',
		props:{
			dataList:{
				type: Array,
				default: () => []
			},
			moreLink: {
			   type: String,
			   default: ''
			}
		},
		methods:{
			setTimeformat(_data,_format='yyyy-mm-dd'){
				return _format.replace(/YYYY/i,_data.substr(0,4)).replace(/MM/i,_data.substr(5,2)).replace(/DD/i,_data.substr(8,2))
			},
			hoverRoll(_data){
			    this.item = _data
			}
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/downList.vue